import React, { useEffect, useState } from "react";
import { getSellerAnalytics } from "../../api/sellerAnalytics.api";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, BarChart, Bar, } from "recharts";

const SellerAnalytics = () => {
  const [data, setData] = useState({
    total_rfqs: 0,
    approved_rfqs: 0,
    rejected_rfqs: 0,
    conversion_rate: 0,
    monthly_trend: []
  });

  useEffect(() => {
    getSellerAnalytics()
      .then(res => {
        setData(res.data.data);
      })
      .catch(err => console.log(err));
  }, []);

  const cards = [
    { label: "Total RFQs", value: data.total_rfqs, icon: "📊" },
    { label: "Approved RFQs", value: data.approved_rfqs, icon: "✅" },
    { label: "Rejected RFQs", value: data.rejected_rfqs, icon: "❌" },
    { label: "Conv. Rate", value: `${data.conversion_rate}%`, icon: "📈" }
  ];

  const cardStyle = {
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    padding: "clamp(15px, 3vw, 24px)",
    height: "100%",
    boxShadow: "0 1px 2px rgba(0,0,0,0.03)"
  };

  const labelStyle = {
    color: "#6b7280",
    fontSize: "clamp(10px, 1.2vw, 11px)",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    marginTop: "10px"
  };

  const valueStyle = {
    color: "#112347",
    fontSize: "clamp(22px, 3vw, 28px)",
    fontWeight: "800",
    margin: 0
  };

  /* PIE DATA */
  const pieData = [
    { name: "Approved", value: data.approved_rfqs },
    { name: "Rejected", value: data.rejected_rfqs },
    { name: "Pending", value: data.total_rfqs - data.approved_rfqs - data.rejected_rfqs }
  ];

  const COLORS = ["#059669", "#dc2626", "#d97706"];

  return (
    <div className="container-fluid p-0">
      
      {/* METRICS */}
      <div className="row g-3 g-md-4 mb-4">
        {cards.map((c, i) => (
          <div className="col-6 col-lg-3" key={i}>
            <div style={cardStyle}>
              <span className="fs-4 opacity-50">{c.icon}</span>
              <h2 style={valueStyle}>{c.value}</h2>
              <div style={labelStyle}>{c.label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* CHARTS */}
      <div className="row g-4">
        
        {/* RFQ TREND */}
        <div className="col-12 col-lg-7">
          <div style={{ ...cardStyle, height: "400px" }}>
            <h6 className="fw-bold" style={{ color: "#112347", marginBottom: "20px" }}>
              RFQ Trends (Monthly)
            </h6>

            <ResponsiveContainer width="100%" height="90%">
              <LineChart data={data.monthly_trend || []}>
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="count" stroke="#112347" strokeWidth={3} />
              </LineChart>
            </ResponsiveContainer>

          </div>
        </div>

        {/* CONVERSION PIE */}
        <div className="col-12 col-lg-5">
          <div style={{ ...cardStyle, height: "400px" }}>
            <h6 className="fw-bold" style={{ color: "#112347", marginBottom: "20px" }}>
              Conversion Breakdown
            </h6>

            <ResponsiveContainer width="100%" height="90%">
              <PieChart>
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={100}
                  paddingAngle={5}
                  dataKey="value"
                >
                  {pieData.map((entry, index) => (
                    <Cell key={index} fill={COLORS[index]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>

          </div>
        </div>

        {/* PRODUCT-WISE RFQs */}
        <div className="row g-4 mt-2">

          <div className="col-12 col-lg-7">
            <div style={{ ...cardStyle, height: "400px" }}>
              <h6 className="fw-bold" style={{ color: "#112347", marginBottom: "20px" }}>
                Product-wise RFQs
              </h6>

              <ResponsiveContainer width="100%" height="90%">
                <BarChart data={data.product_wise || []}>
                  <XAxis dataKey="product_name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="total_rfqs" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* TOP PRODUCTS */}
          <div className="col-12 col-lg-5">
            <div style={{ ...cardStyle, height: "400px" }}>
              <h6 className="fw-bold" style={{ color: "#112347", marginBottom: "20px" }}>
                Top Performing Products
              </h6>

              <div className="p-2">
                {(data.top_products || []).map((p, i) => (
                  <div key={i} className="d-flex justify-content-between mb-3">
                    <span style={{ fontWeight: "600" }}>{p.product_name}</span>
                    <span style={{ color: "#059669", fontWeight: "700" }}>
                      {p.approved_count} Approved
                    </span>
                  </div>
                ))}
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default SellerAnalytics;